import BaseInputComponent from "basecomponents/BaseInputComponent";
import { connect } from "react-redux";
import PropTypes from "prop-types";

// Components
import { InputField } from "../components/form";
import { Button } from "../components/button";
import Table from "../components/table";
import PaginationBar from "../components/paginationBar";

// Modals
import AddPackageModal from "modals/AddPackageModal";

// Interfaces
import { IAPackage } from "../interfaces/IPackage";

// Actions
import { getAdminPackages, deletePackage } from "../actions/packageActions";

// Utils
import { getPackageStatus, getWeightType } from "../utils/packageUtils";
import { showModal, showPopUpConfirmation } from "../utils/domUtils";
import { formatDate } from "../utils/date";

class AdminDPackages extends BaseInputComponent {
  state = {
    field: "",
  };

  idmodal_add_package = "modal_add_package";
  todayDate = new Date();

  componentDidMount() {
    this.searchConfig.getResultsFunctionName = "getAdminPackages";
    this.searchConfig.propsObjectName = "package";
    this.getResults();
  }

  onTablePageClick = (newPage) => {
    this.getResultsForComponent({ currentPage: newPage });
  };

  onKeyUpField = () => {
    this.handleSearchField(this.state.field);
  };

  getResults(searchData = null) {
    // @ts-ignore
    this.props.getAdminPackages(searchData);
  }

  isLoading(): boolean {
    // @ts-ignore
    return this.props.package.loading;
  }

  getComponentResults(): Array<IAPackage> {
    // @ts-ignore
    const results: Array<IAPackage> = this.props.package.elements;
    return results;
  }

  onAddPackageClick = () => {
    showModal(this.idmodal_add_package);
  };

  onDeletePackageClick = (item: IAPackage) => {
    showPopUpConfirmation(
      `Realmente desea elminar al paquete "${item.name}"?`,
      "Esta accion eliminara este registro y dejara a todos sus articulos sin paquete",
      (confirmation) => {
        if (!confirmation) return;
        this.onConfirmDeletePackage(item);
      }
    );
  };

  onConfirmDeletePackage = (item: IAPackage) => {
    // @ts-ignore
    this.props.deletePackage(item.id);
  };

  onShowPackageDetailsClick = (item: IAPackage) => {};

  getInputSearch = () => {
    const { field } = this.state;
    return (
      <div className="input-search mb-2">
        <InputField
          id="field"
          name="field"
          placeholder="Buscar..."
          value={field}
          onChange={this.onChangeTextInput}
          onKeyUp={this.onKeyUpField}
        />
      </div>
    );
  };

  getResultsTable = () => {
    return (
      <>
        <Table
          isLoading={this.isLoading()}
          results={this.getComponentResults()}
          headers={[
            "",
            "ID",
            "Estado",
            "Articulos",
            "Peso",
            "Nombre",
            "Propietario",
            "Fecha de creaci&oacute;n",
          ]}
          getRowFN={this.getResultsTableRow}
        />
        <PaginationBar
          pagination={
            // @ts-ignore
            this.props.package.pagination
          }
          onPageClick={this.onTablePageClick}
        />
      </>
    );
  };

  getResultsTableRow = (item: IAPackage, uuid_key) => {
    return (
      <tr key={uuid_key}>
        <td>
          <div className="dropdown">
            <button
              className="btn btn-link"
              type="button"
              id={`dropdown_${item.id}`}
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
            >
              <i className="feather icon-more-vertical-"></i>
            </button>
            <div
              className="dropdown-menu"
              aria-labelledby={`dropdown_${item.id}`}
            >
              <a
                className="dropdown-item"
                href="#!"
                onClick={this.onShowPackageDetailsClick.bind(this, item)}
              >
                <i className="feather icon-eye mr-2"></i>Detalles
              </a>
              <a
                className="dropdown-item"
                href="#!"
                onClick={this.onDeletePackageClick.bind(this, item)}
              >
                <i className="feather icon-trash mr-2"></i>Eliminar
              </a>
            </div>
          </div>
        </td>
        <td>{item.id}</td>
        <td>{getPackageStatus(item.status)}</td>
        <td>
          {item.count_articles} / {item.count_articles_received}
        </td>
        <td>
          {item.weight} {getWeightType(item.weight_type)}
        </td>
        <td>{item.name || ""}</td>

        <td>{`${item.client_code || ""} ${item.owner || ""}`}</td>
        <td>{formatDate(item.created_date, this.todayDate)}</td>
      </tr>
    );
  };

  render() {
    return (
      <>
        <div className="row">
          <div className="col-12">
            <div className="card">
              <div className="card-header">
                <div className="card-title">
                  <span>Listado de paquetes</span>
                  <Button
                    icon="icon-plus"
                    extraClass="btn-primary pull-right"
                    onClick={this.onAddPackageClick}
                  />
                </div>
                <div className="card-body">
                  {this.getInputSearch()}
                  {this.getResultsTable()}
                </div>
              </div>
            </div>
          </div>
        </div>

        <AddPackageModal />
      </>
    );
  }
}

// @ts-ignore
AdminDPackages.propTypes = {
  package: PropTypes.object.isRequired,
  getAdminPackages: PropTypes.func.isRequired,
  deletePackage: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  package: state.package,
});

export default connect(mapStateToProps, {
  getAdminPackages,
  deletePackage,
})(AdminDPackages);
